const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    wrapper: {
      extend: theme.wrapper,
      width: '100%',
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      overflow: 'hidden',
    },
    postList: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      paddingTop: 50,
      borderTop: `1px solid ${theme.colors[6]}`,
    },
    item: {
      width: '46%',
      display: 'flex',
      alignItems: 'flex-start',
    },
    itemImage: {
      width: '33%',
      overflow: 'hidden',
      borderRadius: 16,
      position: 'relative',
      zIndex: 1,
      '&::before': {
        content: '""',
        width: '100%',
        display: 'block',
        paddingBottom: '100%',
      },
    },
    itemInfo: {
      padding: [0, 40],
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    },
    itemCategory: {
      fontSize: 10,
      textTransform: 'uppercase',
      color: theme.colors[3],
      marginBottom: 20,
    },
    itemTitle: {
      fontSize: 22,
      lineHeight: 1,
      color: theme.colors[0],
      marginBottom: 20,
      '& a': {
        color: theme.colors[0],
      },
    },
    itemText: {
      color: theme.colors[5],
      fontSize: 13,
      '& p': {
        marginBottom: 0,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    postList: {
      flexDirection: 'column',
      '& > *:not(:last-child)': {
        marginBottom: 40,
      },
    },
    item: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    itemImage: {
      width: '100%',
      '&::before': {
        paddingBottom: '56.25%',
      },
    },
    itemInfo: {
      padding: [20, 0],
    },
  }

  return output
}
export default style
